<template>
  <div class="newsmain">
      <div class="main">
          <div class="bgc"></div>
          <div class="con">
                <div class="text-con">
                  <div class="title">新闻资讯</div>
                  <!-- <div class="conter" v-for="(item,index) in 10" :key="index" @click="detailsClick">
                      <span class="text">关于近期第三方冒用“隆携小贷”名称、Logo并制作虚假APP 进行诈骗的严正声明</span>
                      <span class="text">2020-07-18 12:12:20</span>
                  </div> -->
                  <div class="conter" v-for="(item,index) in list.records" :key="index" @click="detailsClick(item.titleId)">
                      <span class="text" :class="{fw:item.titleBold==1,color:item.titleColor=='red'}">{{item.title}}</span>
                      <span class="text">{{item.modifyTime | formatTime}}</span>
                  </div>
                  <div class="pagination">
                    <div class="con">
                        <!-- 分页功能 -->
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[5, 10, 20, 50, 100]" :page-size="5" background layout="total,prev,pager,next,sizes" :total="total"></el-pagination>
                    </div>
                  </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import {getNewsList} from '../../api/news'
export default {
    name:'news',
    methods:{
        detailsClick(id){
            console.log("id", id)
            this.$router.push({
              path: `/details/${id}`,
              query: {
                menType: '1',
              },
            })
        },
        // 获取数据的方法
        getList(){
            // 获取列表数据第一页要5条
           getNewsList({
             menType: 1,
            // 页码
            page:this.page,
            // 页容量
            size:this.size
        }).then(res=>{
            //成功回调
            // console.log(res)
            this.list = res.data.data
            // 设置总条数
            this.total = res.data.data.total
        })
        },
         handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        // 保存当前页容量
        this.size = val
        // 重新获取数据
        this.getList()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        // 保存当前页
        this.page = val
        // 重新获取数据
        this.getList()
      }
    },
    data(){
        return{
            page:1,
            size:5,
            list:[] ,
            total:20,
        }
    },
    created(){
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
    .newsmain{
        .main{
          .bgc{
               width: 100%;
               height: 500px;
               background: url("../../assets/新闻资讯.jpg") center bottom no-repeat;
               background-size: 100% 122%;
               background-position-y: -80px;
               image-rendering: -moz-crisp-edges;
               image-rendering: -o-crisp-edges;
               image-rendering: -webkit-optimize-contrast;
               image-rendering: crisp-edges;
               -ms-interpolation-mode: nearest-neighbor;
            }
            .con{
                padding: 20px;
                text-align: left;
                .text-con{
                    .title{
                        font-size: 30px;
                        padding-bottom: 20px;
                    }
                    p{
                        margin: 0;
                    }
                    .conter{
                        display: flex;
                        justify-content: space-between;
                        font-size: 18px;
                        border-bottom: 1px dashed #ccc;
                        margin-top: 15px;
                        cursor: pointer;
                        .text{
                            padding-bottom: 10px;
                        }
                    }
                    .pagination{
                        width: 100%;
                        padding-top: 20px;
                        .con{
                            margin: 0 auto;
                            text-align: center;
                        }
                    }
                }
            }
        }
        .fw {
            font-weight: 700;
        }
        .color {
            color: red;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/News/index.vue